const messages = {
  buttonText: 'CONTINUAR',
  title: 'Recibe cada 3 meses un par de retenedores',
  description: 'Escribe tus datos para poder comenzar tu suscripción',
  loaderText: 'Estamos registrando tus datos…'
}

export default messages
